<script setup>
import { onMounted, ref } from 'vue'
import { useI18n } from "vue-i18n";
import { useRouter } from 'vue-router'
import { useAuthenticationStore } from '@/stores/authentication.js'
import { useModalStore } from '@/stores/modal.js'

//Components
import SettingsLayout from '@/views/settings/components/settings_sidebar.vue';

// Stores
const router = useRouter()
const authenticationStore = useAuthenticationStore()
const modalStore = useModalStore()

// I18n
const { t } = useI18n();

// Variables
const isLoading = ref(true);

// Event Handlers
onMounted(async () => {
  if (!authenticationStore.currentUser) {
    router.replace({ name: 'LandingPage' })
    modalStore.setModal(modalStore.modalTypeConstants.LOGIN)
  }
})
</script>

<template>
  <div class="container mx-auto grow">
    <div class="flex flex-col px-4 lg:flex-row lg:px-8 lg:py-4">
      <SettingsLayout class="w-full lg:w-1/4 border-b lg:border-b-0 lg:border-r border-gray-300" />
      <div class="px-2 lg:px-10 py-6 w-full lg:w-3/4">
        <router-view name="mainContent"></router-view>
      </div>
    </div>
  </div>
</template>


<style lang="scss" scoped>
@import '@/assets/styles/views/settings/personal_information';
</style>
